export default "__VITE_ASSET__014dc12b__"